import { render } from "./ProductBrandingComponent.vue?vue&type=template&id=bb5f5522"
import script from "./ProductBrandingComponent.vue?vue&type=script&lang=js"
export * from "./ProductBrandingComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__